import React from "react";
import classNames from "classnames/bind";
import styles from "./Header.module.scss";

import { RiLogoutCircleRLine } from "react-icons/ri";

const cx = classNames.bind(styles);

export default function Header({ currentTitle, user, handleLogout }) {
  return (
    <div className={cx("container")}>
      <p className={cx("title")}>{currentTitle}</p>
      <div className={cx("logo_out_box")}>
        <p className={cx("logo_out_text")}>{user?.username}</p>
        <button className={cx("logo_out_button")} onClick={handleLogout}>
          <RiLogoutCircleRLine className={cx("logo_out_icon")} />
        </button>
      </div>
    </div>
  );
}
